<template>
  <div class="content">
    <div class="contentTop">
      <div class="lthHeaderCnt">
        <div class="lBtn selectAll" v-if="1>2">
          <div class="theSelect"><div class="selectIn"></div></div>
        </div>
        <div class="lBtn add" v-on:click="addContent">
          Add New Slider
        </div>
        <div class="searchCnt">
          <form v-on:submit.prevent="search">
            <input type="text" class="field" placeholder="Search content..."
              v-on:input="search" v-model="query">
            <button></button>
          </form>
        </div>
        <div class="pagination">
          <div class="pageInfo">{{((page * limit) + 1).toLocaleString('id')}}-{{((page
            * limit) + results.length).toLocaleString('id')}} dari
            {{total.toLocaleString('id')}}</div>
          <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
            v-on:click="prevPage"></div>
          <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
            * limit) + results.length) >= total}"
            v-on:click="nextPage"></div>
          <div class="pageBtn refresh" v-on:click="getData"></div>
          <div class="pageBtn download" v-on:click="getData"></div>
          <div class="pageBtn filter" :class="{open: filterOpen}"
            v-on:click.stop="filterOpen = !filterOpen">
            <div class="ddCnt" v-on:click.stop="doNothing" v-if="filterOpen">
              <div class="ddItem">
                <h4>Density</h4>
                <div class="radioCnt">
                  <div class="radioItem density" v-on:click="setDensity('default')">
                    <div :class="{radio: 1, checked: density === 'default'}"></div>
                    Comportable
                    <img src="../assets/density-default.png">
                  </div>
                  <div class="radioItem density" v-on:click="setDensity('compact')">
                    <div :class="{radio: 1, checked: density === 'compact'}"></div>
                    Compact
                    <img src="../assets/density-compact.png">
                  </div>
                </div>
              </div>
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setItemPerPage(5)">
                    <div :class="{radio: 1, checked: limit === 5}"></div>
                    5 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(10)">
                    <div :class="{radio: 1, checked: limit === 10}"></div>
                    10 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(25)">
                    <div :class="{radio: 1, checked: limit === 25}"></div>
                    25 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(50)">
                    <div :class="{radio: 1, checked: limit === 50}"></div>
                    50 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(100)">
                    <div :class="{radio: 1, checked: limit === 100}"></div>
                    100 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(150)">
                    <div :class="{radio: 1, checked: limit === 150}"></div>
                    150 item per page
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pageBtn config" :class="{open: configOpen}"
            v-on:click.stop="configOpen = !configOpen">
            <div class="ddCnt" v-on:click.stop="doNothing" v-if="configOpen">
              <div class="ddItem">
                <h4>Density</h4>
                <div class="radioCnt">
                  <div class="radioItem density" v-on:click="setDensity('default')">
                    <div :class="{radio: 1, checked: density === 'default'}"></div>
                    Comportable
                    <img src="../assets/density-default.png">
                  </div>
                  <div class="radioItem density" v-on:click="setDensity('compact')">
                    <div :class="{radio: 1, checked: density === 'compact'}"></div>
                    Compact
                    <img src="../assets/density-compact.png">
                  </div>
                </div>
              </div>
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setItemPerPage(5)">
                    <div :class="{radio: 1, checked: limit === 5}"></div>
                    5 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(10)">
                    <div :class="{radio: 1, checked: limit === 10}"></div>
                    10 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(25)">
                    <div :class="{radio: 1, checked: limit === 25}"></div>
                    25 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(50)">
                    <div :class="{radio: 1, checked: limit === 50}"></div>
                    50 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(100)">
                    <div :class="{radio: 1, checked: limit === 100}"></div>
                    100 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(150)">
                    <div :class="{radio: 1, checked: limit === 150}"></div>
                    150 item per page
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tabCnt">
        <div class="tab tab1 published" :class="{active: tabActive === 'published'}"
          v-on:click="selectTab('published')">Published</div>
        <div class="tab tab4 unpublished" :class="{active: tabActive === 'unpublished'}"
          v-on:click="selectTab('unpublished')">Unpublished</div>
        <div class="tab tab99 deleted" :class="{active: tabActive === 'deleted'}"
          v-on:click="selectTab('deleted')">Deleted</div>
      </div>
    </div>

    <perfect-scrollbar class="listingCntSc">
      <div class="listingCnt">
        <div class="listingItemCnt">
          <table>
            <tbody v-if="loading">
              <tr>
                <td colspan="5" class="tdLoading">
                  <SkAnimation :thumb="false" :tab="false" :header="false" :type="'article'"/>
                </td>
              </tr>
            </tbody>
            <tbody v-else :class="density">
              <tr v-if="results.length < 1" class="loadingTr">
                <td colspan="2" class="loadingCnt">
                <div class="dataEmptyCnt" v-if="results.length < 1">
                  <div class="submissionEmpty">
                    <div class="emptyImg"/>
                    <h4>No Content Created Yet</h4>
                    <p>Content slider will appear here, add new content by clicking
                      Add New Slider button on top of the page.</p>
                  </div>
                </div>
              </td></tr>
              <tr v-for="(item, index) in results" :key="index">
                <td class="td1">
                  <div class="articleCnt">
                    <div class="thumb" :style="{'background-image': `url(${item.media.imageMd})`}"
                      v-if="item.media && item.media.type === 'image'"/>
                    <div class="thumb" :style="{'background-image': `url(${item.media.mainThumb})`}"
                      v-else-if="item.media && item.media.type === 'video'"/>
                    <div class="thumb" :style="{'background-image': `url(${item.media.cover})`}"
                      v-else-if="item.media && item.media.type === 'pdf'"/>
                    <div class="thumb" :style="{'background-image': `url(${item.media.thumb})`}"
                      v-else-if="item.media && item.media.type === 'youtube'"/>
                    <div class="thumb noImg" v-else></div>
                    <h4>{{item.title}}</h4>
                    <p v-if="item.buttonLabel && item.buttonUrl">
                      {{item.buttonLabel}} <span>&bull;</span> {{item.buttonUrl}}</p>
                    <div class="authorInfo">
                      <div :class="{authorImg: true, hasPhoto: item.author.avatar}"
                        :style="{'background-image': `url('${item.author.avatar}')`}"
                        v-if="item.author">
                        <span>{{item.author.name.substr(0,2)}}</span>
                      </div>
                      <h4>{{item.author.name}}</h4>
                    </div>
                  </div>
                </td>
                <td class="tdAction">
                  <div class="actionWrapper">
                    <div class="action" v-on:click="itemOpenedId = item.id"></div>
                    <div :class="{actionOverlay: true, open: itemOpenedId == item.id}"
                      v-on:click="itemOpenedId = null"></div>
                    <div :class="{actionCnt: true, open: itemOpenedId == item.id}">
                      <div class="actionItem" v-on:click="editItem(index, item)">
                        <img src="../assets/edit-black.png"> Edit Slider
                      </div>
                      <div class="actionItem" v-on:click="unpublish(index, item)">
                        <img src="../assets/private.png"> Unpublish
                      </div>
                      <div class="divider"></div>
                      <div class="actionItem actionRed" v-on:click="deleteData(index, item)"
                        v-if="item.isDeleted === 1">
                        <img src="../assets/delete.png"> Delete permanently
                      </div>
                      <div class="actionItem actionRed" v-on:click="deleteData(index, item)"
                        v-else>
                        <img src="../assets/delete.png"> Delete
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </perfect-scrollbar>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <MediaSelector ref="mediaSelector"/>
    <LoadingDialog ref="loadingDialog" />
    <ShareDialog ref="shareDialog"/>
    <FormInputerShort ref="formInputer"/>
    <AddSlider ref="addSlider"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import ShareDialog from '@/components/ShareDialog.vue';
import AddSlider from '@/components/AddSlider.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';

export default {
  name: 'articles',
  components: {
    Confirmation,
    Snackbar,
    SkAnimation,
    MediaSelector,
    LoadingDialog,
    AddSlider,
    ShareDialog,
    FormInputerShort,
  },
  data() {
    return {
      loading: true,
      results: [],
      itemOpenedId: null,
      searchTimer: null,
      limit: 5,
      page: 0,
      total: 0,
      density: 'default',
      tabActive: 'published',
      query: '',
      configOpen: false,
      filterOpen: false,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    doNothing() {},
    selectTab(tab) {
      if (tab === this.tabActive) return;
      this.tabActive = tab;
      window.history.replaceState({}, tab, `/content/${this.parent.slug}?tab=${tab}`);
      this.page = 0;
      this.getData();
    },
    setDensity(density) {
      this.configOpen = false;
      localStorage.setItem('articleDensity', density);
      this.density = density;
    },
    setItemPerPage(itemPerPage) {
      this.configOpen = false;
      localStorage.setItem('articleItemPerPage', itemPerPage);
      this.limit = itemPerPage;
      this.getData();
    },
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getData();
      }, 500);
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      this.getData();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      this.getData();
    },
    deleteData(i, item) {
      this.itemOpenedId = null;
      this.$refs.confirmDialog.open({
        title: 'Delete Slider',
        desc: `Are you sure you want to delete this slider?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow(i, item);
      });
    },
    deleteNow(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted content,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Content',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`slider/${item.id}/delete`)).then((r) => {
          if (r.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: 'Slider has been deleted.', action: null }, (sb) => {});
        });
      });
    },
    editItem(i, item) {
      this.itemOpenedId = null;
      this.$refs.addSlider.open(item, (b, o) => {
        if (!b) return;
        this.getData();
      });
    },
    addContent() {
      this.$refs.addSlider.open(null, (b, o) => {
        if (!b) return;
        this.getData();
      });
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri('slider/all')).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {
    this.chCGB(false);
    this.chTitle('Home Slider');
    this.getData();
  },
};
</script>


<style scoped lang="scss">
  .tabCnt{
    .tab{
      width: 33.3333%;
    }
  }
  .dataEmptyCnt{
    position: relative;
    height: calc(100vh - 144px);
  }
  .submissionEmpty{
    text-align: center;
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    h4{
      margin: 0;
      font-size: 32px;
      color: #767676;
      font-weight: normal;
      margin-bottom: 10px;
    }
    p{
      font-size: 15px;
      color: #767676;
      margin-bottom: 30px;
      max-width: 500px;
      white-space: normal;
      line-height: 1.4;
    }
    .btn{
      // border: #0747a6 2px solid;
      border-radius: 50px;
    }
    .emptyImg{
      width: 300px; height: 300px;
      background-image: url(../assets/trash-empty.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      margin: 0 auto 20px;
      display: none;
    }
  }
  .listingItemCnt{
    margin: 0 -30px;
  }
  .listingHeader{
    padding: 5px 20px;
    padding-left: 18px;
    .exportAll{
      float: right;
      background-color: #0057d8;
      font-size: 15px;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all .2s linear;
      color: #fff;
      cursor: pointer;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
    .exportAll:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }
    .lhItem{
      font-size: 15px;
      float: left;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      opacity: .5;
      transition: all .2s linear;
      cursor: pointer;
      position: relative;
      padding-left: 150px;
      float: none;
      margin-right: 0;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
      .checkAll{
        width: 14px; height: 14px;
        border: #777 2px solid;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
      }
      &.addContent{
        display: block;
        color: #444;
      }
    }
    .lhItem.rejectAll{
      opacity: 1;
      color: red;
    }
    .lhItem:before{
      content: "";
      position: absolute;
      left: 12px; top: 2px;
      width: 120px; height: 30px;
      background-color: #ddd;
      border-radius: 4px;
    }
    .lhItem:hover{
      // background-color: #eee;
      opacity: 1;
    }
  }
  table{
    border-collapse: collapse;
    width: 100%;
    tr{
      &:hover{
        background-color: #f5f5fe;
      }
      &.loadingTr{
        cursor: default;
        &:hover{
          background-color: #fff;
        }
      }
      th{
        text-align: left;
        font-weight: bold;
        color: #999;
        padding: 10px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        text-transform: uppercase;
        white-space: nowrap;
      }
      td{
        padding: 14px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        position: relative;
        white-space: nowrap;
        vertical-align: top;
        &.tdLoading{
          padding: 0 30px;
          // border: none;
          &:hover{
            background-color: #fff;
          }
        }
        .articleCnt{
          min-height: 150px;
        }
        &.loadingCnt{
          padding: 0 30px;
          border-bottom: none;
        }
        .thumb{
          left: 30px;
          top: 14px;
          position: absolute;
          width: 120px;
          height: 150px;
          // height: 80px;
          // top: 20px;
          background-color: #e5e5e5;
          // background-color: #fff;
          background-size: cover;
          background-position: top center;
          background-repeat: no-repeat;
          border-radius: 4px;
          opacity: 1;
          &.noImg{
            background-image: url(../assets/image-white.png);
            background-size: 46px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.audio{
            background-color: #d9d6e4;
            background-image: url(../assets/musical-note-blue.svg);
            background-size: 36px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.processing{
            z-index: 1;
            background: orange !important;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
              position: relative;
              z-index: 3;
              color: #444;
              font-size: 14px;
            }
            @-webkit-keyframes MOVE-BG {
              from {
                -webkit-transform: translateX(0);
              }
              to {
                -webkit-transform: translateX(46px);
              }
            }
            @keyframes MOVE-BG {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(46px);
              }
            }
            &:before{
              display: block;
              content: "";
              position: absolute;
              left: -46px;
              right: 0;
              top: 0;
              bottom: 0;
              z-index: 1;
              background: -webkit-repeating-linear-gradient(
                145deg,
                rgba(0,0,0,.1) 1px,
                rgba(0,0,0,0) 2px,
                rgba(0,0,0,0) 11px,
                rgba(0,0,0,.1) 12px,
                rgba(0,0,0,.1) 20px
              );
              background: repeating-linear-gradient(
                -55deg,
                rgba(0,0,0,.1) 1px,
                rgba(0,0,0,0) 2px,
                rgba(0,0,0,0) 11px,
                rgba(0,0,0,.1) 12px,
                rgba(0,0,0,.1) 20px
              );
              -webkit-animation-name: MOVE-BG;
              -webkit-animation-duration: .6s;
              -webkit-animation-timing-function: linear;
              -webkit-animation-iteration-count: infinite;
              animation-name: MOVE-BG;
              animation-duration: .6s;
              animation-timing-function: linear;
              animation-iteration-count: infinite;
            }
          }
        }
        .actionWrapper{
          position: relative;
          display: flex;
          justify-content: flex-end;
          padding-right: 10px;
          .ttCnt{
            position: relative;
            .tt{
              position: absolute;
              top: 100%; right: -20px;
              background-color: rgba(0,0,0,.8);
              color: #fff;
              padding: 4px 10px;
              border-radius: 3px;
              display: none;
              font-size: 13px;
            }
            &:hover{
              .tt{
                display: block;
              }
            }
          }
        }
        .deliveryStats{
          display: flex;
          font-size: 13px;
          align-items: center;
          color: #767676;
          .statsItem{
            padding: 5px 10px;
            padding-left: 32px;
            position: relative;
            border-radius: 50px;
            cursor: pointer;
            &:before{
              content: "";
              position: absolute;
              left: 10px; top: 0; bottom: 0;
              width: 16px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              opacity: .5;
            }
            &:hover{
              background-color: #d7d7ea;
              color: #444;
              &:before{
                opacity: .6;
              }
            }
            &.waStats{
              &:before{
                background-image: url(../assets/whatsapp-o.png);
              }
            }
            &.smsStats{
              &:before{
                background-image: url(../assets/sms-o.png);
              }
            }
          }
        }
        .action{
          margin-top: -4px;
          position: relative;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-size: 18px auto;
          background-repeat: no-repeat;
          background-position: center;
          opacity: .4;
          cursor: pointer;
          &.star{
            background-image: url(../assets/star.png);
            &.stared{
              opacity: 1;
              background-image: url(../assets/star-active.png);
            }
          }
          &.share{
            background-image: url(../assets/share.png);
          }
          &.stats{
            background-image: url(../assets/stats.png);
          }
          &:hover{
            background-color: #d7d7ea;
            opacity: .7;
          }
        }
        .actionCnt{
          position: absolute;
          background: #fff;
          top: 100%;
          // border: 1px solid #ccc;
          box-shadow: 1px 1px 4px rgba(0,0,0,.2);
          border-radius: 10px;
          padding: 10px 0;
          white-space: nowrap;
          text-align: left;
          right: 14px;
          z-index: 4;
          margin-top: -5px;
          display: none;
          .divider{
            border-top: #eee 1px solid;
            padding-top: 4px;
            margin-top: 4px;
          }
          .actionItem{
            display: block;
            cursor: pointer;
            list-style: none;
            padding: 7px 42px;
            color: #444;
            font-size: 14px;
            min-width: 100px;
            img{
              height: 15px;
              margin: -4px 4px -2px -22px;
            }
          }
          .actionItem.actionRed{
            color: red;
          }
          .actionItem:hover{
            background-color: #eee;
          }
        }
        .actionCnt.open{
          display: block;
        }
        .actionOverlay{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          display: none;
        }
        .actionOverlay.open{
          display: block;
        }
      }
      td.td1{
        padding-left: 170px;
        h4{
          margin: 6px 0 14px;
          font-size: 24px;
          font-weight: normal;
          white-space: normal;
          span{
            background: #777;
            color: #fff;
            font-size: 15px;
            padding: 2px 7px;
            border-radius: 3px;
            margin-left: 10px;
            margin-top: 5px;
          }
        }
        .draft{
          padding: 2px 7px 4px;
          background-color: #222;
          color: #fff;
          border-radius: 3px;
          margin-right: 5px;
          &.unpublished{
            background-color: #999;
          }
        }
        .itemLabel{
          display: inline-block;
          color: #777;
          padding: 2px 7px 4px;
          background-color: #eee;
          margin-right: 5px;
          border-radius: 3px;
          position: relative;
          font-weight: 600;
          &.wa{
            background-color: #4caf50;
            background-image: linear-gradient(to right, #4caf50, #00af04);
            padding-left: 28px;
            color: #fff;
            &:before{
              content: "";
              position: absolute;
              width: 16px;
              top: 0; bottom: 0; left: 6px; right: 0;
              background-image: url(../assets/whatsapp-o-white.png);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          &.sms{
            background-color: #f48604;
            background-image: linear-gradient(to right, #f48604, #f9a71a);
            padding-left: 26px;
            color: #fff;
            &:before{
              content: "";
              position: absolute;
              width: 16px;
              top: 0; bottom: 0; left: 6px; right: 0;
              background-image: url(../assets/sms-o-white.png);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          &.article{
            background-color: #f17e2e;
            background-image: linear-gradient(to right, #f17e2e, #ffb100);
            padding-left: 28px;
            color: #fff;
            &:before{
              content: "";
              position: absolute;
              width: 16px;
              top: 0; bottom: 0; left: 6px; right: 0;
              background-image: url(../assets/draft.png);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
        }
        .pricingInfo{
          // border: #999 1px solid;
          background-color: #eee;
          border-radius: 3px;
          margin: 10px 0 0;
          margin-right: 5px;
          display: inline-block;
          color: #0f5cd2;
          // color: #444;
          padding: 2px 7px 4px;
          font-weight: 600;
          .pricing{
            position: relative;
            .pricingName{
              max-width: 200px;
              overflow: hidden;
              display: inline-block;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-bottom: -4px;
            }
            .info{
              float: right;
              color: #0057d8;
              border: #0057d8 1px solid;
              height: 18px;
              width: 18px;
              text-align: center;
              border-radius: 50%;
              margin-left: 7px;
              margin-top: 2px;
              line-height: 1;
              font-size: 14px;
              padding-top: 1px;
              box-sizing: border-box;
              cursor: pointer;
              .theInfo{
                background-color: #222;
                position: absolute;
                font-size: 14px;
                padding: 10px;
                color: #fff;
                border-radius: 5px;
                z-index: 9;
                left: 100%; top: -6px;
                margin-left: 5px;
                box-shadow: 2px 2px 6px rgba(0,0,0,.2);
                width: 260px;
                line-height: 1.3;
                white-space: normal;
                text-align: left;
                display: none;
                font-weight: normal;
              }
              &:hover{
                .theInfo{
                  display: block;
                }
              }
            }
          }
          &.hasPrice{
            background-color: #0f5cd2;
            background-color: #0f5cd2;
            background-image: linear-gradient(to right, #0065ff, #02a08f);
            // border-color: #0f5cd2;
            color: #fff;
            .pricing{
              .info{
                border-color: #fff;
                color: #fff;
              }
            }
          }
        }
        p{
          margin: 0;
          white-space: normal;
          font-size: 17px;
          color: #767676;
          span{
            margin: 0 10px;
          }
        }
        .authorInfo{
          position: relative;
          padding-top: 16px;
          padding-left: 50px;
          padding-bottom: 16px;
          margin-top: 6px;
          .authorImg{
            position: absolute;
            left: 0;
            top: 8px;
            width: 39px;
            height: 39px;
            background-color: #ec174c;
            font-weight: 600;
            font-size: 18px;
            // background-image: url(../assets/user.png);
            background-size: cover;
            background-position: center;
            border-radius: 50%;
            // cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            text-transform: uppercase;
            line-height: 0;
            &.hasPhoto{
              span{
                display: none;
              }
            }
          }
          h4{
            margin: 0;
            font-size: 17px;
          }
          .publishTime{
            margin: 0;
            font-size: 13px;
            position: relative;
            padding-left: 20px;
            &:before{
              width: 14px;
              left: 0; top: 0; bottom: 1px;
              content: "";
              position: absolute;
              background-image: url(../assets/calendar.png);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              opacity: .9;
            }
          }
        }
      }
      td.tdHeader{
        padding: 0;
      }
    }
    tbody.compact{
      tr{
        td{
          &.td1{
            .articleCnt{
              min-height: 120px;
              .thumb{
                height: 120px;
              }
              h4{
                font-size: 22px;
                margin-bottom: 0;
              }
              p{
                display: none;
              }
              .authorInfo{
                display: flex;
                padding-left: 0;
                .authorImg{
                  display: none;
                }
                h4{
                  position: relative;
                  font-size: 15px;
                  padding-right: 16px;
                  margin-right: 8px;
                  &:before{
                    content: "";
                    width: 6px; height: 6px;
                    border-radius: 50%;
                    position: absolute;
                    top: 7px; right: 0;
                    background-color: #767676;
                    display: none;
                  }
                }
                .publishTime{
                  font-size: 15px;
                  color: #767676;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
